import * as types from '../../actions/actiontypes';
import initialState from '../initialstate';
import { currentResource } from '../../util/utils';

export default function copyhubPackagesReducer(state = initialState.copyhubPackageList, action) {
    switch (action.type) {
        case types.GET_COPYHUB_PACKAGE_LIST: {
                return action.response;
                }
        
        case types.RESET_PACKAGE_LIST: {
                return initialState.copyhubPackageList;
        }
        default:
            return state;
    }
}